import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import "./App.css";
import FirstForm from "./pages//first-form/first-form.component";
import SuccessForm from "./pages/success-form/success-form.component";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FirstForm />} />
          <Route path="/:itemID" element={<FirstForm />} />
          <Route path="/submitSuccess" element={<SuccessForm />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
